import { padStart } from 'lodash-es';
import { emitLog } from './log';
import { getBytes } from './utils';

export const parseNumber = (generator: MyGenerator, config: DpMapItem, result: any) => {
  const { extension } = config;
  const value = generator.nextNumber(config, result);
  if (extension) {
    const { min = -Infinity, max = Infinity } = extension;
    return Math.max(Math.min(value, max), min);
  }
  return value;
};

export const parseSignedNumber = (generator: MyGenerator, config: DpMapItem, result: any) => {
  const { extension } = config;
  const bytes = getBytes(config, result);
  const hex = generator.next(config, result);
  let value = parseInt(hex, 16);
  const signed = value >> (bytes * 8 - 1); // 取得符号位
  // 是否为负值
  if (signed) {
    let base = 0; // 数值的范围
    switch (bytes) {
      case 1:
        base = 0xff >> 1;
        break;
      case 2:
        base = 0xffff >> 1;
        break;
      case 3:
        base = 0xffffff >> 1;
        break;
      case 4:
        base = 0xffffffff >> 1;
        break;
      default:
        console.warn('有符号数值最大支持32位数值，无法表示');
    }
    // 先计算负值的绝对值原码（去除符号位后，取反码+1），然后乘以 -1
    value = (((value & base) ^ base) + 1) * -1;
    console.log('value', value, base);
  }
  if (extension) {
    const { min = -Infinity, max = Infinity } = extension;
    return Math.max(Math.min(value, max), min);
  }
  return value;
};

export const parseString = (generator: MyGenerator, config: DpMapItem, result: any) => {
  return generator.next(config, result);
};

export const parseBoolean = (generator: MyGenerator, config: DpMapItem, result: any) => {
  return generator.nextBoolean(config, result);
};

export const parseEnum = (generator: MyGenerator, config: DpMapItem, result: any) => {
  const { extension, name } = config;
  const enumValue = generator.nextNumber(config, result);
  if (extension) {
    // 是否有扩展值，则检验是否值标准
    const { range } = extension;
    if (Array.isArray(range) && range.length) {
      if (range.includes(enumValue)) {
        return enumValue;
      } else {
        // 提示校验失败，返回了枚举第一个值
        emitLog({
          type: 'warning',
          message: `解析到属性【${name}】时，得到的值${enumValue}未在可枚举范围内`,
          data: { [name]: enumValue },
        });
        return range[0];
      }
    }
  }
  return enumValue;
};

export const parseBit = (generator: MyGenerator, config: DpMapItem, result: any) => {
  return generator.nextBits(config, result);
};
export const parseBits = (generator: MyGenerator, config: DpMapItem, result: any) => {
  const { numType = 'hex', bitType = 'right' } = config;
  const value = generator.next(config, result);
  const radix = numType === 'dec' ? 10 : 16;
  const bits: Array<1 | 0> = [];
  for (let i = 0; i < value.length; i += 2) {
    const temp = parseInt(value.slice(i, i + 2), radix);
    const bit = padStart(temp.toString(2), 8, '0')
      .split('')
      .map(v => Number(v)) as Array<1 | 0>;
    bits.push(...bit);
  }
  // 是否为从右边取数据
  if (bitType === 'right') {
    bits.reverse();
  }
  return bits;
};

export const parseWeek = (generator: MyGenerator, config: DpMapItem, result: any) => {
  return parseBit(generator, config, result).slice(0, 7);
};

export const parseCustom = (generator: MyGenerator, config: DpMapItem, result: any) => {
  const { parse, name } = config;
  const value = generator.next(config, result);
  const num = parseInt(value, 16);
  if (typeof parse === 'function') {
    return parse(num, value);
  }
  // 提示配置有误
  emitLog({
    type: 'warning',
    message: `解析自定义类型属性【${name}】时，检测到未配置 parse 函数`,
    data: {
      [name]: num,
    },
  });
  return num;
};

export const parseNumberBySeparate = (generator: MyGenerator, config: DpMapItem, result: any) => {
  const { extension, numType = 'hex' } = config;
  const bytes = getBytes(config, result);
  if (bytes === 1) {
    return generator.nextNumber(config, result);
  }
  const value = generator.next(config, result);
  let total = 0;
  for (let i = 0; i < value.length; i += 2) {
    const num =
      parseInt(value.slice(i, i + 2), numType === 'dec' ? 10 : 16) * 10 ** (value.length - 2 - i);
    total += num;
  }
  if (extension) {
    const { min = -Infinity, max = Infinity } = extension;
    return Math.max(Math.min(total, max), min);
  }
  return total;
};
